<template>
  
  <div class="chartSoc">
    <div class="chartItemTitulo">Estado da Carca</div>
    <div class="chartItemIcone">
      <i class="fas fa-battery-empty"></i>
    </div>
    <div class="chartItemValor">0 % </div>
  </div>

</template>

<script>

export default {
    name: 'ChartSOC'
}
</script>

<style>
.chartSoc {
  position: relative;
  width:100%;
  min-width: 200px;
  height: 100%;
  min-height: 300px;
}
.chartItemTitulo {
  font-family: 'Play';
  font-size: 2em;
  color: #ffd618;
  text-align: center;
  padding-top: 20px;
  height: 20px;
}
.chartItemIcone {
  font-family: 'Play';
  font-size: 10em;
  color: #008fac;
  text-align: center;
  height: 100px;
  padding-top: 20px;
}
.chartItemValor {
  font-family: 'Play';
  font-size: 4em;
  color: #eee;
  font-weight: bold;
  text-align: center;
  padding-top: 100px;
}
</style>